import * as Yup from 'yup';
import { DataSource } from '@models';
import { cronFormatCheck } from '@utils/functions';

export function useValidationSchema() {
  return Yup.object<DataSource>().shape({
    name: Yup.string().nullable().required(),
    owner: Yup.string().nullable().required(),
    area: Yup.string().nullable().required(),
    documentUrlMask: Yup.string().nullable().required(),
    incrementalImportCron: Yup.string()
      .test(
        'is-filled',
        'Chybný formát. (Např. "0 1 * * */6" ) Pro zrušení časování ponechte pole prázdné.',
        (value) => {
          if (!value) return true;

          return cronFormatCheck(value);
        }
      )
      .nullable(),
  });
}
